import { render, staticRenderFns } from "./Administrator.vue?vue&type=template&id=4bb8eb95&scoped=true"
import script from "./Administrator.vue?vue&type=script&lang=js"
export * from "./Administrator.vue?vue&type=script&lang=js"
import style0 from "./Administrator.vue?vue&type=style&index=0&id=4bb8eb95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb8eb95",
  null
  
)

export default component.exports